import React, { Component } from "react";
import { Grid } from "react-bootstrap";
//import { version } from "../../../package.json";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a href="/admin">
              ICHTYS Technology S.A.
            </a>
            {/*{" "}— v{version}*/}
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
